import React, { useMemo } from 'react';
import InlineListField from './InlineListField';
import { getTimeOptions, withInjectedTimeOptions } from './utils';

export type TimeListFieldProps = {
    title: string;
    value: string | null; // HH:mm
    onChange: (value: string) => void;
    testID: string;
    error?: string;
};

/** Inline 15-min slot time select (Select look, prompt-safe). */
const TimeListField: React.FC<TimeListFieldProps> = ({ title, value, onChange, testID, error }) => {
    const options = useMemo(() => withInjectedTimeOptions(getTimeOptions(), [value]), [value]);

    return (
        <InlineListField
            title={title}
            value={value}
            options={options}
            onChange={onChange}
            testID={testID}
            error={error}
            fallbackScrollValue="08:00"
        />
    );
};

export default React.memo(TimeListField);
